import { BrowserLogger } from "@ciaopeople/cp-shatsu/Logging";
import { ThrottleClause } from "../ThrottledChainableEvaluation.js";
import { ThrottleStore } from "./ThrottleStore.js";

let _logger = null;

function getLogger() {
    if(!_logger) {
        _logger = new BrowserLogger("[CTA-Throttle]");
    }
    return _logger;
}

export class TimeThrottleClause implements ThrottleClause {
    
    private readonly timeInMsec: number;

    constructor(
        timeInSeconds: number, 
        private readonly throttleStore: ThrottleStore
    ) {
        
        this.timeInMsec = timeInSeconds * 1000;
    }
    
    public clearThrottle(): Promise<void> {
        return this.throttleStore.store(0);
    }
   
    checkIfShouldExecute(): Promise<boolean> {
        return this.throttleStore.retrieve().then(lastExec => {
            const lastExecutionInMsec = lastExec * 1000;
            const currTime = new Date().getTime();
            const diff = currTime - lastExecutionInMsec;
            const reval = diff >= this.timeInMsec;
            getLogger().debug("Checking throttle lastExec", currTime, "-", lastExecutionInMsec, "=", diff, ">=", this.timeInMsec, "?", reval);
            return reval;
        }); 
    }
    setExecuted(): Promise<void> {
        const epoch = Math.floor(new Date().getTime() / 1000);
        getLogger().debug("Setting throttle last exec now", epoch);
        return this.throttleStore.store(epoch);
    }

}